import imageOne from '@/assets/images/cities/toronto1.jpg'
import imageTwo from '@/assets/images/cities/toronto2.jpg'
import imageThree from '@/assets/images/cities/toronto3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Toronto',
  writeup: '',
  website: 'TotalTorontoNotary.com',
  url: 'https://www.totaltorontonotary.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(647) 795-2772',
      hours: {
        monday: '6:30PM to 9:00PM',
        tuesday: '6:30PM to 9:00PM',
        wednesday: '6:30PM to 9:00PM',
        thursday: '6:30PM to 9:00PM',
        friday: 'Closed',
        saturday: '10:00AM to 5:00PM',
        sunday: '10:AM to 9:00PM'
      },
      address: 'Mill Street (Downtown) Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/cities/toronto.js